import { FirebaseAuthProvider } from 'react-admin-firebase';
import { FirebaseConfig, FirebaseOptions } from '../config/firebase';
import { PANEL_LOGIN_ROLE_IDS } from '../constants/croles';
import apiAuthProvider from './apiAuthProvider';

const useApiAuth = process.env.REACT_APP_USE_API_AUTH === 'true';

// Firebase provider'ini SADECE Firebase auth modunda kur. API modunda
// (anahtarlar .env'den silinmis olabilir) kurmaya calisirsak uygulama
// mount olmadan coker -> bos sayfa.
const buildFirebaseAuthProvider = () => {
  const baseAuthProvider = FirebaseAuthProvider(FirebaseConfig, FirebaseOptions);
  return {
    ...baseAuthProvider,
    login: async (params) => {
      const user = await baseAuthProvider.login(params);
      const claims = await baseAuthProvider.getPermissions();
      const ALLOWED_ROLES = PANEL_LOGIN_ROLE_IDS;
      const canEnter = claims.crole && ALLOWED_ROLES.includes(claims.crole);
      if (canEnter) return user;
      await baseAuthProvider.logout();
      throw new Error('Login error, invalid permissions');
    },
  };
};

export default useApiAuth ? apiAuthProvider : buildFirebaseAuthProvider();
